import Vue from 'vue';
import store from '@/store';
import { z_get, z_post, z_patch, z_put, z_delete, z_geturl } from '@/api/httpASP';
import * as custom from '@/common/js/filter';
import * as commonMethods from "@/common/js/commonMethods";

//http
Vue.prototype.z_get = z_get;
Vue.prototype.z_post = z_post;
Vue.prototype.z_patch = z_patch;
Vue.prototype.z_put = z_put;
Vue.prototype.z_delete = z_delete;
Vue.prototype.z_geturl = z_geturl;

//系统变量
Vue.prototype.$SYSTEM_CODE = process.env.SYSTEM_CODE;
Vue.prototype.$SYSTEM_NAME = process.env.SYSTEM_NAME;
Vue.prototype.$SYSTEM_ICON = process.env.SYSTEM_ICON;

//zj_log()可以在html打印
Vue.prototype.zj_log = window.console.log;

//注册全局方法
Object.keys(commonMethods).forEach(key => {
  Vue.prototype[key] = commonMethods[key];
})

//注册全局filter的同时注册为全局方法
Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key]);
  Vue.prototype[key] = custom[key];
})

//关闭生产模式下给出的提示
Vue.config.productionTip = false;

//是否系统管理员
Vue.prototype.$isAdmin = function () {
  if (store.state.accountInfo == null) {
      throw { message: "请在获取用户信息后使用该方法" };
  }
  var roleinfos = store.state.accountInfo.roleinfos;
  if (!roleinfos) return false;
  for (let i = 0; i < roleinfos.length; i++) {
      const role = roleinfos[i];
      if (role.is_sys_role && (role.role_sys_code == "admin" || role.role_sys_code == "developer")) {
          return true;
      }
  }
  return false;
}

//是否开发人员
Vue.prototype.$isDeveloper = function () {
  if (store.state.accountInfo == null) {
      throw { message: "请在获取用户信息后使用该方法" };
  }
  var roleinfos = store.state.accountInfo.roleinfos;
  if (!roleinfos) return false;
  for (let i = 0; i < roleinfos.length; i++) {
      const role = roleinfos[i];
      if (role.is_sys_role && (role.role_sys_code == "developer")) {
          return true;
      }
  }
  return false;
}

//获得用户信息/角色
Vue.prototype.$getAccountInfo = () => store.state.accountInfo;
Vue.prototype.$getRoles = function () {
    if (store.state.accountInfo == null) {
        throw { message: "请在获取用户信息后使用该方法" };
    }
    store.state.accountInfo.roleinfos;
}
